import React, {useEffect} from 'react';
import {Button, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../store';
import {AsyncTaskStatusType} from '../../shared/dtos';
import ErrorText from '../../components/ErrorText';
import CustomDialog from '../../components/CustomDialog';
import {deleteFolderFromLegalCaseAction} from '../../api/legalCase';
import {setDeleteFolderTaskStatus} from '../../features/legal-case/legalCaseSlice';

interface DeleteFolderDialogProps {
    handleClose: () => void;
    handleDelete: () => void;
    caseId: number;
    folderId: number;
    folderName: string;
}

export const DeleteFolderDialog: React.FC<DeleteFolderDialogProps> = ({
                                                                          handleClose,
                                                                          handleDelete,
                                                                          caseId,
                                                                          folderId,
                                                                          folderName,
                                                                      }) => {
    const deleteFolderTaskStatus = useSelector((state: AppState) => state.legalCase.deleteFolderTaskStatus);
    const dispatch: any = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(setDeleteFolderTaskStatus(null));
        };
    }, [dispatch]);

    const handleDeleteClick = async () => {
        try {
            const result = await dispatch(deleteFolderFromLegalCaseAction({caseId, folderId}));
            if (result.type === 'legalcase/deleteFolderFromLegalCase/fulfilled') {
                handleDelete();
                handleClose();
            }
        } catch (error) {
            console.error('Klasör silme işleminde bir hata oluştu:', error);
        }
    };

    return (
        <CustomDialog open={true} onClose={handleClose}>
            <DialogTitle>Klasörü Sil ({folderName})</DialogTitle>
            <DialogContent>
                Bu klasörü silmek istediğinizden emin misiniz?
                {deleteFolderTaskStatus?.type === AsyncTaskStatusType.Error &&
                    deleteFolderTaskStatus.errorMessage && (
                        <ErrorText type="form" message={deleteFolderTaskStatus.errorMessage}/>
                    )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>İptal</Button>
                <Button onClick={handleDeleteClick} color="error">
                    Sil
                </Button>
            </DialogActions>
        </CustomDialog>
    );
};
